import { ActivityLevel } from "@/clients/models/ActivityLevel";
import { ActivityLevelService } from "@/clients/services/ActivityLevelService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateActivityLevel = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKeys.ACTIVITY_LEVEL],
    mutationFn: async (data: ActivityLevel) => {
      const user = guardGetUserFromLocalStorage();
      await ActivityLevelService.updateActivityLevelApiV1ActivityLevelPut(user.id, data);
    },
    onSuccess: () => {
      // Activity level recomputes calories & macros on the backend.
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.CALORIE_BUDGET],
      });
    },
  });

  return {
    updateActivityLevel: mutation.mutate,
    updateActivityLevelAsync: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
